export default function Confidentialite() {
  return (
    <div className="em-container py-16 max-w-3xl">
      <h1 className="font-display text-4xl font-black text-primary">Politique de confidentialité</h1>
      <div className="mt-8 space-y-6 text-muted-foreground leading-relaxed">
        <section>
          <h2 className="font-display text-xl font-bold text-primary mb-2">Données collectées</h2>
          <p>Energy Market collecte les données transmises via les formulaires de contact, de demande d'étude, de dépôt de facture et de téléchargement de ressources : nom, prénom, téléphone, email, société, secteur d'activité, type d'énergie, message et pièces jointes.</p>
        </section>
        <section>
          <h2 className="font-display text-xl font-bold text-primary mb-2">Finalité</h2>
          <p>Ces données sont utilisées uniquement pour traiter votre demande, vous recontacter et réaliser l'étude de votre situation énergétique. Elles ne sont jamais cédées à des tiers à des fins commerciales.</p>
        </section>
        <section>
          <h2 className="font-display text-xl font-bold text-primary mb-2">Vos droits (RGPD)</h2>
          <p>Conformément au Règlement Général sur la Protection des Données, vous disposez d'un droit d'accès, de rectification, d'effacement et d'opposition. Pour l'exercer, contactez-nous à contact@energy-market.fr.</p>
        </section>
        <p className="text-sm">Page à compléter par l'éditeur — structure conforme au cahier des charges.</p>
      </div>
    </div>
  );
}
